import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .user-org-contents {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .user-org-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .user-org-subtitle {
    font-size: 14px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .user-org-input-container {
    width: 100%;
  }
  .user-org-input-row-container {
    display: flex;
    justify-content: space-between;
  }
  .user-org-input-container {
    display: flex;
    flex-direction: column;
  }
  .user-switch-wrapper {
    margin-bottom: 3px;
  }
  .user-org-contact-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .user-org-contact-modal-row {
    display: flex;
    padding-bottom: 10px;
  }
  .street-number-input {
    width: 150px;
    margin-left: 10px;
  }
  .postal-code-input {
    width: 250px;
    margin-right: 10px;
  }
  .user-org-date {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .button-container {
    padding: 8px 0;
  }
  .user-org-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .user-org-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
